import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { SET_VALUE, SET_TYPE, SET_ANIMATING } from '../../actions/poster'
import TextInput from '../../components/TextInput/'
import RadioGroup from '../../components/RadioInput/'
import SelectInput from '../../components/SelectInput/'
import Loader from '../../components/Loader/'
import * as generate from '../../generate'
import NAMES from '../../templates/config'
import './style.css'

class App extends React.Component {

	state = {
		loading: false,
		field_type: '',
		field_color: '',
		orientation: 'staand'
	}

	combinations = {
		'ouders_2': {
			label: "Vrouw met kind",
			text: "Op de fiets naar school?",
			environments: [
				{ id: 'stedelijk', label: 'Stedelijk' },
				{ id: 'dorp', label: 'Dorps' },
				{ id: 'landelijk', label: 'Landelijk' },
			]
		},
		'ouders': {
			label: "Man met kind",
			text: "Op de fiets naar school?",
			environments: [
				{ id: 'stedelijk', label: 'Stedelijk' },
				{ id: 'dorp', label: 'Dorps' },
				{ id: 'landelijk', label: 'Landelijk' },
			]
		},
		
		'forenzen': {
			label: 'Forens 1',
			text: "Op de fiets naar werk?",
			environments: [
				{ id: 'stedelijk', label: 'Stedelijk' },
				{ id: 'landelijk', label: 'Landelijk' },
			]
		},
		'forenzen_2': {
			label: 'Forens 2',
			text: "Op de fiets naar werk?",
			environments: [
				{ id: 'stedelijk', label: 'Stedelijk' },
				{ id: 'dorp', label: 'Dorps' },
				{ id: 'landelijk', label: 'Landelijk' },
			]
		},
		'senioren': {
			label: 'Senioren',
			text: "Rondje fietsen?",
			environments: [
				{ id: 'stedelijk', label: 'Stedelijk' },
				{ id: 'dorp', label: 'Dorps' },
				{ id: 'landelijk', label: 'Landelijk' },
			]
		}
	}

	handleOrientationChange = (e) => {
		const newOrientation = e.target.value;
		this.setState({ orientation: newOrientation });

		let currentType = this.props.selection.type;
		let newType = currentType;

		if (newOrientation === 'staand') {
			if (currentType.startsWith('landscape_')) {
				newType = currentType.replace('landscape_', '').toLowerCase();
			} else {
				newType = 'a0';
			}
		} else {
			const staandTypes = ['a7','a6','a5','a4','a3','a0','50_76','banner'];
			if (staandTypes.includes(currentType)) {
				if (currentType === '50_76' || currentType === 'banner') {
					newType = currentType;
				} else {
					newType = 'landscape_' + currentType.toUpperCase();
				}
			} else {
				newType = 'landscape_A0';
			}
		}

		this.props.actions.SET_TYPE(newType);
	}

	getFormatOptions = () => {
		if (this.state.orientation === 'staand') {
			return [
				{id: 'a7', label: NAMES['a7'].title},
				{id: 'a6', label: NAMES['a6'].title},
				{id: 'a5', label: NAMES['a5'].title},
				{id: 'a4', label: NAMES['a4'].title},
				{id: 'a3', label: NAMES['a3'].title},
				{id: 'a0', label: NAMES['a0'].title},
				{id: '50_76', label: NAMES['50_76'].title},
				{id: 'banner', label: NAMES['banner'].title},
			]
		}

		return [
			{id: 'landscape_A7', label: NAMES['a7'].title},
			{id: 'landscape_A6', label: NAMES['a6'].title},
			{id: 'landscape_A5', label: NAMES['a5'].title},
			{id: 'landscape_A4', label: NAMES['a4'].title},
			{id: 'landscape_A3', label: NAMES['a3'].title},
			{id: 'landscape_A0', label: NAMES['a0'].title},
		]
	}

	handleSubmit = () => {
		window.trackGenerate(
			NAMES[this.props.selection.type].title,
			this.props.poster.field_type,
			this.props.poster.field_where,
			this.props.poster.field_color
		)

		this.setState({ loading: true })

		if(this.props.selection.type === '50_76') {
			generate.size_50_76(`${this.props.poster.field_where}`).then(() => {
				setTimeout(() => {
					this.setState({loading: false})
				}, 1000)
			})
		} else {
			generate[this.props.selection.type](`${this.props.poster.field_where}`).then(() => {
				setTimeout(() => {
					this.setState({loading: false})
				}, 1000)
			})
		}
	}

	handleTypeChange = (data) => {
		this.props.actions.SET_ANIMATING(true, 350).then(() => {
			this.props.actions.SET_TYPE(data)
			this.setState({ field_color: '' })
			this.props.actions.SET_ANIMATING(false, 0)
		})
	}

	handleFieldTypeChange = (data) => {
		this.setState({ field_type: data })
		this.props.actions.SET_VALUE(data, 'field_type')

		let newColor = this.props.poster.field_color

		// ensure valid color
		if (!this.combinations[data].environments.find(env => env.id === newColor)) {
			newColor = this.combinations[data].environments[0].id

			this.setState({ field_color: newColor })
			this.props.actions.SET_VALUE(newColor, 'field_color')
		}

		// get label from combinations
		const text = this.combinations[data].text

		// update text input value
		this.props.actions.SET_VALUE(text, 'field_where')
	}

	render() {
		return (
			<React.Fragment>

				{this.state.loading && <Loader />}

				<div className="form-row form-row--start">
					<div className="form-row__label"><span>Kies je poster</span></div>
					<div className="form-row__input">
						<fieldset className="form-row__fieldset">
							<legend className="sr-only">Kies je poster</legend>
							<RadioGroup
								onChange={this.handleFieldTypeChange}
								selected={this.props.poster.field_type}
								field="field_type"
								options={
									Object.entries(this.combinations).map(([key, value]) => ({
										id: key,
										label: value.label
									}))
								}
							/>
						</fieldset>
					</div>
				</div>

				<div className="form-row">
					<div className="form-row__label">
						<label htmlFor="select"><span>Omgeving</span></label>
					</div>
					<div className="form-row__input">
						<div className="form-row__meta" id="background">Kies een achtergrond</div>
						<SelectInput
							id="select"
							options={
								Object.entries(this.combinations[this.props.poster.field_type].environments)
									.map(([key, value]) => ({
										id: value.id,
										label: value.label
									}))
							}
							field="field_color"
						/>
					</div>
				</div>

				<div className="form-row">
					<div className="form-row__label">
						<label htmlFor="field_where"><span>Tekst</span></label>
					</div>
					<div className="form-row__input">
						<div className="form-row__meta" id="town">Vul je eigen tekst of plaatsnaam in</div>
						<TextInput limit={30} id="field_where" field="field_where" />
					</div>
				</div>

				<div className="form-row">
					<div className="form-row__label">
						<label><span>Kies orientatie</span></label>
					</div>
					<div className="form-row__input">
						<select
							className="select-input"
							value={this.state.orientation}
							onChange={this.handleOrientationChange}
						>
							<option value="staand">Staand</option>
							<option value="liggend">Liggend</option>
						</select>
					</div>
				</div>

				<div className="form-row form-row--start">
					<div className="form-row__label">
						Kies formaat
					</div>

					<fieldset className="form-row__fieldset">
						<legend className="sr-only">
							Poster formaten
						</legend>

						<div className="form-row__input form-row__input--cols">
							<RadioGroup
								onChange={this.handleTypeChange}
								selected={this.props.selection.type}
								field="type"
								options={this.getFormatOptions()}
							/>
						</div>
					</fieldset>
				</div>

				<div className="form-row">
					<div className="form-row__label"></div>
					<div className="form-row__input">
						<button
							onClick={this.handleSubmit}
							className="form-row__submit"
							disabled={this.state.loading}
						>
							Download
						</button>
					</div>
				</div>

			</React.Fragment>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		poster: state.poster,
		selection: state.selection
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		actions: bindActionCreators({SET_VALUE, SET_TYPE, SET_ANIMATING}, dispatch)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(App)